export const environment = {
  apiBaseUri: 'https://convergent-stg-purview-api.azurewebsites.net/api',
  apimOverrideUri: 'https://api-stage.getconvergent.io/carefindr/apim2',
  apimOverrideUriV2: 'https://api-stage.getconvergent.io/carefindr/apim3',
  apiV2BaseUri: 'https://convergent-stg-carefindr-func.azurewebsites.net/api'
};
